import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'
import insertScript from '../../../assets/scripts/utilities/insert-script.js'

const isReducedMotion = !!(window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true)

const CLOSE_TIMEOUT_DELAY = 150

let closeTimeout
class MicrioOverlayComponent extends Component {
  init() {
    this.closeButton = this.element.querySelector('.button--close')
    this.closeButton?.addEventListener('click', event => this.closeOverlay(event))

    window.addEventListener('micrio-overlay', event => this.initAfterData(event.detail || {}))
    window.history.replaceState(null, '', window.location.pathname)
  }

  async initAfterData({ id, isObject = false }) {
    if (!id) {
      return
    }

    if (this.embed) {
      this.embed?.remove()
      this.embed = null
    }

    await insertScript('micrio-script', 'https://b.micr.io/micrio-4.3.min.js')

    if (!document.getElementById(id)) {
      this.embed = document.createElement('micr-io')
      this.embed.id = id
    } else {
      this.embed = document.getElementById(id)
    }

    this.embed.lang = document.documentElement.lang === 'fi' ? 'nl' : 'en' // string	en	The data language code to use

    if (!isObject) {
      this.embed.setAttribute('router', 'hash') // string	hash	How to handle the URL routing. Can be hash or history

      this.embed.defaultSettings = this.embed.defaultSettings || {}
      this.embed.defaultSettings._markers = this.embed.defaultSettings._markers || {}
      this.embed.defaultSettings._markers.autoStartTour = true
      this.embed.defaultSettings._markers.tourAutoProgress = true
    }

    this.setMicrioSettings()

    this.embed.addEventListener('show', event => this.onMicrioShow(event))
    this.embed.addEventListener('tour-stop', event => this.onMicrioTourStop(event))

    this.element.appendChild(this.embed)
    this.element.classList.add('micrio-overlay--active')
  }

  closeOverlay(event) {
    if (!this.embed) {
      return
    }

    event?.preventDefault()
    window.history.replaceState(null, '', window.location.pathname)

    this.embed?.remove()
    this.embed = null
    this.element.classList.remove('micrio-overlay--active')
  }

  setMicrioSettings() {
    this.embed.setAttribute('lazyload', 'true')
    this.embed.setAttribute('camspeed', isReducedMotion ? '0' : '2')
    this.embed.setAttribute('events', 'true')
    this.embed.setAttribute('keys', 'true')
    this.embed.setAttribute('zooming', 'true')
    this.embed.setAttribute('dragging', 'true')
    this.embed.setAttribute('controls', 'true')
    this.embed.setAttribute('fullscreen', 'false')
    this.embed.setAttribute('social', 'false')
    this.embed.setAttribute('logo', 'false')
    this.embed.setAttribute('toolbar', 'false')
    this.embed.setAttribute('show-info', 'false')
    this.embed.setAttribute('minimap', 'false')
  }

  onMicrioShow() {
    this.autoStartThemeTour()
  }

  onMicrioTourStop(event) {
    if (!event.detail?.duration) {
      // This is a theme tour, not a chapter tour
      return
    }

    window.clearTimeout(closeTimeout)
    closeTimeout = window.setTimeout(() => this.closeOverlay(event), CLOSE_TIMEOUT_DELAY)
  }

  onMicrioMarkerClosed() {
    if (!this.tour) {
      return
    }

    this.tour.initialStep = this.tourStep
    this.embed.state.tour.set(this.tour)
  }

  autoStartThemeTour() {
    if (!this.embed?._current?.$data?.markerTours?.length) {
      return
    }

    const tours = [...this.embed._current.$data.markerTours]
    const themeTour = tours.filter(({ autostart }) => !!autostart)[0]

    if (!themeTour) {
      return
    }

    themeTour.cannotClose = true
    themeTour.initialStep = 0

    this.tour = themeTour
    this.embed.state.tour?.set(themeTour)
    // TODO: This doesn't seem to work

    //if (this.embed._current?.__info?.settings?._markers?.autoStartTour) {
    //  this.embed._current.__info.settings._markers.autoStartTour = true
    //  this.embed._current.__info.settings._markers.tourAutoProgress = true
    //}
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'micrio-overlay', MicrioOverlayComponent))
